module.exports = __webpack_public_path__ + "static/media/code-help.9a7949b6.svg";